export const LineIcon = () => (
  <svg width="20px" height="20px" x="0px" y="0px" fill="currentColor" viewBox="0 0 22 22">
    <rect x="0" y="12" width="22" height="1" />
  </svg>
)